<template>
  <div>
    <Panel :label="$t('Document')">
      <div style="position: relative">
	<PanelBlock v-show="items.length > 0">
	  <p class="control">
	    <b-input
	      v-model="filterValue"
	      type="search"
	      icon="search"
	      expanded
	    >
	    </b-input>
	  </p>
	</PanelBlock>
	<PanelBlock v-for="item in filteredItems" :key="item.value">
	  <b-field>
	    <template #label>
	      <b-checkbox
		:value="item.selected"
		@input="handleInput(item.value, $event)"
	      >
		{{ item.value }} ({{ item.count }})
	      </b-checkbox>
	    </template>
	  </b-field>
	</PanelBlock>
	<!-- show selected items if no matches -->
	<PanelBlock v-for="item in selectedItems" :key="item.value">
	  <b-field>
	    <template #label>
	      <b-checkbox
		:value="item.selected"
		@input="handleInput(item.value, $event)"
	      >
		{{ item.value }} ({{ item.count }})
	      </b-checkbox>
	    </template>
	  </b-field>
	</PanelBlock>
	<b-loading :active="loading" :is-full-page="false"></b-loading>
      </div>
    </Panel>
  </div>
</template>

<script>
 import Panel from '@/components/Panel.vue'
 import PanelBlock from '@/components/PanelBlock.vue'

 import { createNamespacedHelpers } from 'vuex'
 const { mapActions, mapGetters } = createNamespacedHelpers('shared')

 export default {
   components: {
     Panel,
     PanelBlock
   },
   model: {
     prop: 'selected',
     event: 'input'
   },
   props: {
     kind: {
       type: String,
       validator: (value) => {
	 return ['title'].includes(value)
       }
     },
     items: {
       type: Array,
       default: () => []
     },
     field: {
       type: String,
       default: 'name'
     },
     selected: {
       type: Array,
       default: () => []
     },
     title: {
       type: String,
       required: true
     },
     loading: {
       type: Boolean,
       default: false
     }
   },
   data() {
     return {
       filterValue: ''
     }
   },
   watch: {
     items() {
       if (this.filterValue !== '') {
	 this.filterValue = ''
       }
     }
   },
   computed: {
     isEmpty() {
       return this.items.length === 0
     },
     titledKind() {
       return [this.kind[0].toUpperCase(), ...this.kind.slice(1)].join('')
     },
     filteredItems() {
       return this.selectableItems.filter((item) => item
	 .value
	 .toString()
	 .toLowerCase()
	 .indexOf(this.filterValue.toLowerCase()) !== -1)
     },
     selectableItems() {
       return this
	 .items
	 .filter((item) => !this.selected.includes(item.value))
	 .map((item) => ({
	   ...item,
	   selected: this.selected.includes(item.value)
	 }))
     },
     selectedItems() {
       if (this.items.length === 0) {
	 return this.selected.map((value) => ({
	   name: value,
	   value: value,
	   count: 0,
	   selected: true,
	 }))
       }
       else {
	 return this
	   .items
	   .filter((item) => this.selected.includes(item.value))
	   .map((item) => ({
	     ...item,
	     selected: this.selected.includes(item.value)
	   }))
       }
     }
   },
   methods: {
     handleInput(id, value) {
       const selected = this.selected

       // only allow single item to be selected
       if (value === true) {
	 if (!selected.includes(id)) {
	   selected.splice(0)
	   selected.push(id)
	 }
       }
       else if (selected.includes(id)) {
	 selected.splice(selected.indexOf(id), 1)
       }

       this.$emit('input', this.selected.slice())
     }
   }
 }
</script>
